/*
---
author:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.4.5: '*'
...
*/

var StyledSelect = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_styled_select',
		selectedIndex: null
	},

	initialize: function(element, options){
		this.setOptions(options);
		this._element = element;

		if(this._element && !this._element.supported) {
			this._element.supported = true;
			this.build();
		}
	},

	build: function(){
		this._select = this._element.getElement('select').hide();
		var self = this;

		this._monitor = this._element.getElement('.monitor') || new Element('button', {
			'class': 'monitor'
		});
		this._styled_select = this._element.getElement('ul') || new Element('ul');

		this._element.adopt(this._monitor).adopt(this._styled_select);
		// var sortDescIconHtml = this._element.get('data-icon-sort-desc') != null ? '<i class="fa fa-sort-desc"></i>' : '';
		var sortDescIconHtml = '<i class="fa fa-sort-desc"></i>';
		this.iconHtml = sortDescIconHtml;

		// set an option by default
		if (typeof(this.options.selectedIndex) !== "undefined" && this.options.selectedIndex !== null) {
			var options = this._element.getElements('select option');
			options[this.options.selectedIndex].selected = true;
		}
		var _selected_option = 	this._select.getElement(':selected') || this._select.getElement('option');


		if (_selected_option) {
			this.text = _selected_option.getAttribute('data-text') || _selected_option.get('text');
		} else {
			this.text = null;
		}


		this._monitor.set('html', this.iconHtml + this.text);

		if(_selected_option.hasClass('_default')){
			this._monitor.addClass('_default');
		}

		this._monitor.addEvents({
			'click': function(e){
				e.preventDefault();
				e.stopPropagation();
				if(self._element.hasClass('opened')){
					self.close_list();
				}else{
					self.open_list();
				}
				self.fireEvent('click');
			}
		});

		this._element.addEvents({
			'mouseleave': this.close_list.bind(this)
		});

		if(Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android'){
			this._styled_select.addClass('_on_scrolling');
		}

		var _existing_options = this._styled_select.getElements('li');


		this._styled_select.empty();

		this._select.getElements('option').each(function(_el, i) {
			var _option = new Element('li.option', {
				'class': 'option ' + (_el.get('class')? _el.get('class') : ''),
				'html': '<a href="#"><i class="fa fa-check" aria-hidden="true"></i>' + (_el.getAttribute('data-text') || _el.get('text') + '</a>')
			});

			if(_existing_options[i] && _existing_options[i].getElement('.config')){
				_existing_options[i].getElement('.config').inject(_option);
			}

			_option._opt = _el;
			_option.inject(self._styled_select);

			if(_el === _selected_option){
				_option.addClass('selected');
				self._selected = _option;
			}

			self.set_option_events(_option);

			_el.addEvent('select', function(){
				_option.fireEvent('select');
			});
		});

		this._adaFix();
	},

	_adaFix: function() {
		this.adaHandle = Core.adaUtility.associateToggleAndDropdown(this._monitor, this._styled_select);
	},

	set_option_events: function(_option){
		var self = this;

		var events = {
			'click': function(e){
				if(e && e.stop) e.stop();

				if(self._selected){
					self._selected.removeClass('selected');
				}

				self._monitor.set('html', self.iconHtml + _option.get('html'));

				if(_option.hasClass('_default')){
					self._monitor.addClass('_default');
				}else{
					self._monitor.removeClass('_default');
				}

				if(_option._opt){
					_option._opt.set('selected', 'selected');
				}

				self.text = _option.get('html');

				self._selected = _option;

				var _selected_option = 	self._select.getElement(':selected') ||
																self._select.getElement('option');

				if (_selected_option) {
					var url = _selected_option.getAttribute('data-href');
					if (url && url != '') {
						window.location = url;
					} else {
						self._select.fireEvent('change', [_selected_option]);
					}
				}

				self.fireEvent('change', [_selected_option]);

				_option.addClass('selected');
				self._element.fireEvent('mouseleave');

				self._element.removeClass('_failed');
			},

			'select': function(){
				if(self._selected){
					self._selected.removeClass('selected');
				}

				self._monitor.set('html', self.iconHtml + _option.get('html'));

				if(_option.hasClass('_default')){
					self._monitor.addClass('_default');
				}else{
					self._monitor.removeClass('_default');
				}

				if(_option._opt){
					_option._opt.set('selected', 'selected');
				}

				self.text = _option.get('html');

				self._selected = _option;

				_option.addClass('selected');
			},

			'mouseenter': function(){
				_option.addClass('_active');
			},

			'mouseout': function(){
				_option.removeClass('_active');
			},

			'mouseleave': function(){
				_option.removeClass('_active');
			}
		};

		_option.addEvents(events);
	},

	open_list: function(){
		this._element.addClass('opened');
		this.adaHandle && this.adaHandle.onOpen();
	},

	close_list: function(){
		this._element.removeClass('opened');
		this.adaHandle && this.adaHandle.onClose();
	},

	reset: function(){
		this._select.getElement('.option').fireEvent('click');
	}
});
